import { ContentClass, SearchFilterContentTypes } from '../../Shared/enums';
import SearchFilterOptions from '../entities/SearchFilterOptions';

export interface LandingHeroContentType {
  id: SearchFilterContentTypes;
  label: string;
  placeholderText: string;
}

// Content-type toggles shown in the landing hero's search bar, keyed off the
// current site's content class (video / audio / image).
const getLandingHeroContentTypes = (): LandingHeroContentType[] | undefined => {
  const contentClass = SearchFilterOptions.getContentClass();

  switch (contentClass) {
    case ContentClass.Video:
      return [
        {
          id: SearchFilterContentTypes.All_videos_content_type,
          label: 'All Video',
          placeholderText: 'Search video library...',
        },
        {
          id: SearchFilterContentTypes.Footage,
          label: 'Footage',
          placeholderText: 'Search footage library...',
        },
        {
          id: SearchFilterContentTypes.Templates,
          label: 'Video Templates',
          placeholderText: 'Search templates library...',
        },
        {
          id: SearchFilterContentTypes.Motion_bgs,
          label: 'Motion Backgrounds',
          placeholderText: 'Search backgrounds library...',
        },
      ];
    case ContentClass.Audio:
      return [
        {
          id: SearchFilterContentTypes.All_audio_content_type,
          label: 'All Audio',
          placeholderText: 'Search audio library...',
        },
        {
          id: SearchFilterContentTypes.Music,
          label: 'Music',
          placeholderText: 'Search music library...',
        },
        {
          id: SearchFilterContentTypes.Sound_effects,
          label: 'Sound Effects',
          placeholderText: 'Search sound effects library...',
        },
      ];
    case ContentClass.Image:
      return [
        {
          id: SearchFilterContentTypes.All_images_content_type,
          label: 'All Images',
          placeholderText: 'Search image library...',
        },
        {
          id: SearchFilterContentTypes.Snapshots,
          label: 'Snapshots (NEW)',
          placeholderText: 'Search snapshot library...',
        },
        {
          id: SearchFilterContentTypes.Photos,
          label: 'Photos',
          placeholderText: 'Search photo library...',
        },
        {
          id: SearchFilterContentTypes.Vectors,
          label: 'Vectors',
          placeholderText: 'Search vector library...',
        },
        {
          id: SearchFilterContentTypes.Illustrations,
          label: 'Illustrations',
          placeholderText: 'Search illustration library...',
        },
      ];
  }
};

export default getLandingHeroContentTypes;
